import React from "react";

export default class GenericInputEle extends React.PureComponent {
    constructor(props) {
        super();
        this.state = {
            isFocus: false,
            value: props.value || ""
        };
        this.onFieldChange = this.onFieldChange.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.toggleEye = this.toggleEye.bind(this);
    }

    onFieldChange(ev) {
        if (this.props.onChange) this.props.onChange(ev, ev.target.value);
    }

    onKeyDown(ev) {
        if (this.props.onKeyDown) this.props.onKeyDown(ev, ev.target.value);
    }

    onFocus(ev) {
        if (this.props.onFocus) this.props.onFocus(ev, ev.target.value);
        this.setState({ isFocus: true });
    }

    onBlur(ev) {
        if (this.props.onBlur) this.props.onBlur(ev, ev.target.value);
        this.setState({ isFocus: false });
    }

    toggleEye() {
        const { eyeOpen } = this.state;
        this.setState({
            eyeOpen: !eyeOpen
        });
    }

    getValidVal = val => {
        if (val === undefined || val === null) {
            return "";
        }

        return val;
    };

    render() {
        const {
            label,
            placeholder,
            required,
            className,
            style,
            name,
            hintText,
            labelStyle = {},
            disabled,
            errorText,
            prefix,
            suffix,
            type,
            id,
            maxLength,
            value
        } = this.props;
        let { isFocus, eyeOpen } = this.state;
        return (
            <div style={{ opacity: disabled ? 0.5 : 1 }} className="div-fullWidth">
                <div className="generic-input-label" style={labelStyle}>
                    {label || ""}
                    {required && label ? <span className="required-input">*</span> : null}
                </div>
                <div className="generic-input-group">
                    {prefix ? (
                        <span
                            className={`${"generic-input-addon generic-input-addonLeft"}
							${isFocus ? "generic-input-focus" : ""} ${errorText ? "generic-error-border" : ""}`}
                        >
                            {prefix}
                        </span>
                    ) : null}
                    <input
                        className={`generic-input ${className || ""}
							${disabled ? "disable-no-drop" : ""}
							${errorText ? "generic-error-border" : ""}
							${isFocus ? "generic-input-focus " : ""}
							${prefix ? "generic-input-prefix-border" : ""}
							${suffix ? "generic-input-suffix-border" : ""}`}
                        placeholder={`${hintText || placeholder || label || ""}`}
                        style={style}
                        disabled={disabled || false}
                        type={type === "password" && !eyeOpen ? "password" : "text"}
                        id={id || null}
                        name={name || null}
                        value={this.getValidVal(value)}
                        onChange={this.onFieldChange}
                        onKeyDown={this.onKeyDown}
                        // onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        maxLength={maxLength}
                    />
                    {type === "password" && value && (
                        <button
                            type="button"
                            className="password-eye-button"
                            onClick={this.toggleEye}
                        >
                            <img
                                alt="password-eye"
                                src={`/assets/images/${eyeOpen ? "show" : "hide"}-password.svg`}
                            />
                        </button>
                    )}
                    {suffix ? (
                        <span
                            className={`${"generic-input-addon generic-input-addonRight"}
							${isFocus ? "generic-input-focus" : ""}
							${errorText ? "generic-error-border" : ""}`}
                        >
                            {suffix}
                        </span>
                    ) : null}
                </div>
                {errorText ? <div className="generic-input-error">{errorText}</div> : null}
            </div>
        );
    }
}
